<style lang="less" scoped>
.FromCenter {margin-top: 20px;}
.btn-wr{text-align: center;}
.code.el-input {width: 472px;}
.validation {width: 140px;}
/deep/ .el-form-item__error {font-size: 14px;}
.tip_p {width: 350px;margin: 5px auto;color: #000;font-size: 14px;display: inline-block;}
.account {margin: 0;text-align: left;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;-khtml-user-select:none;user-select:none;}
</style>

<template>
  <div class="FromCenter">
    <el-form ref="forgotPasswordForm" :model="forgotPasswordForm" :rules="forgotPasswordFormRules" class="demo-ruleForm" label-width="100px">
      <el-form-item prop="NewPwd" label ="新密码:">
        <el-input v-model="forgotPasswordForm.NewPwd" placeholder="新密码:6~16位字符，区分大小写" type="password"></el-input>
      </el-form-item>
      <el-form-item prop="confirmPwd" label ="确认密码:">
        <el-input v-model="forgotPasswordForm.confirmPwd" placeholder="请输入确认密码" type="password"></el-input>
      </el-form-item>
      <el-form-item label ="手机:" v-if="verificationForm.type === 'telno'">
        <p class="account">{{ verificationForm.value }}</p>
      </el-form-item>
      <el-form-item label ="邮箱:" v-else>
        <p class="account">{{ verificationForm.value }}</p>
      </el-form-item>
      <el-form-item label ="验证码:">
        <el-input v-model="forgotPasswordForm.code" placeholder="请输入验证码" class="code"></el-input>
        <el-button type="primary" :disabled="flag" class="validation" @click="getnoCode()">{{ msg }}</el-button>
      </el-form-item>
    </el-form>
    <p class="tip_p" v-if="isShow">验证码5分钟之内有效,请注意查收</p>
    <div class="btn-wr">
      <el-button type="primary" @click="resetPassword()">确认修改</el-button>
    </div>
  </div>
</template>

<script>
/**
 * 安进
 * 忘记密码——重置密码
 */
export default {
  props: ['verificationForm'],
  data()
  {
    let validateNewPwd = (rule, value, callback) =>
    {
      let regtel = /^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{6,16}$/
      if (value === '')
        callback(new Error('请输入新密码'))
      else
      {
        if (!regtel.test(value))
          callback(new Error('密码为6-16位大小写字母和数字组合，请重新输入'))
        else
          callback()
      }
    }
    let validateConfirmPass = (rule, value, callback) =>
    {
      if (value === '')
        callback(new Error('请输入确认密码'))
      else
      {
        if (value !== this.forgotPasswordForm.NewPwd)
          callback(new Error('两次输入密码不一致,请重新输入'))
        else
          callback()
      }
    }
    return {
      // 密码以及验证码
      forgotPasswordForm: {
        NewPwd: '',
        confirmPwd: '',
        code: ''
      },
      // 密码正则
      forgotPasswordFormRules: {
        NewPwd: [
          { validator: validateNewPwd, trigger: 'blur' }
        ],
        confirmPwd: [
          { validator: validateConfirmPass, trigger: 'blur' }
        ]
      },
      msg: '获取验证码',
      flag: false,
      isShow: false
    }
  },
  methods: {
    // 获取验证码
    getnoCode()
    {
      let paras = {
        cmd: 'noCode',
        no: this.verificationForm.no,
        type: this.verificationForm.type,
        value: this.verificationForm.value
      }
      window.post.getLoginSvr(paras).then(ret =>
      {
        if (ret.ret === 0)
        {
          if (this.verificationForm.type === 'telno')
            this.$message({message: '短信已发送至您的手机，请在验证码有效期使用', type: 'success', customClass: 'mzindex'})
          else if (this.verificationForm.type === 'email')
            this.$message({message: '验证码已发送至您的邮箱，请在验证码有效期使用', type: 'success', customClass: 'mzindex'})
          //获取验证码按钮倒计时功能的实现
          const _this = this
          this.flag = true//按钮不可重复点击
          _this.isShow = true//显示提示文字
          var time = 60//定义时间变量 60s
          var timer = null//定义定时器
          timer = setInterval(function()
          {
            if (time === 0)
            {
              _this.msg = '重新获取验证码'
              _this.flag = false
              _this.isShow = false
              clearInterval(timer)//清除定时器
            }
            else
            {
              _this.msg = time + '秒后重新获取'
              time--
            }
          }, 1000)
        }
        else
        {
          switch (ret.errcode)
          {
          case 'errNoUser':
            this.$message({message: '暂无此用户', type: 'error', customClass: 'mzindex'})
            break
          case 'errNoParams':
            this.$message({message: '未指定验证方式', type: 'error', customClass: 'mzindex'}
            )
            break
          case 'errType ':
            this.$message({message: '无此验证方式', type: 'error', customClass: 'mzindex'})
            break
          case 'errNoTel':
            this.$message({message: '此用户未绑定手机', type: 'error', customClass: 'mzindex'})
            break
          case 'errTel':
            this.$message({message: '此用户绑定手机匹配失败', type: 'error', customClass: 'mzindex'})
            break
          case 'errNoEmail':
            this.$message({message: '此用户未绑定邮箱', type: 'error', customClass: 'mzindex'})
            break
          case 'errEmail':
            this.$message({message: '此用户绑定邮箱匹配失败', type: 'error', customClass: 'mzindex'})
            break
          }
        }
      })
    },
    // 重置密码
    resetPassword()
    {
      if (this.forgotPasswordForm.NewPwd !== '' && this.forgotPasswordForm.confirmPwd !== '' && this.forgotPasswordForm.code !== '')
      {
        this.$refs.forgotPasswordForm.validate(valid =>
        {
          if (valid)
          {
            let paras = {
              cmd: 'retrievePsw',
              no: this.verificationForm.no,
              type: this.verificationForm.type,
              value: this.verificationForm.value,
              vrycode: this.forgotPasswordForm.code,
              newpassword: this.forgotPasswordForm.confirmPwd,
              _userId: this.verificationForm.userid
            }
            window.post.getLoginSvr(paras).then(ret =>
            {
              if (ret.ret === 0)
                this.$parent.activeadd(3)
              else
              {
                switch (ret.errcode)
                {
                case 'errNoUser':
                  this.$message({message: '暂无此用户', type: 'error', customClass: 'mzindex'})
                  break
                case 'errNoParams':
                  this.$message({message: '未指定验证方式', type: 'error', customClass: 'mzindex'})
                  break
                case 'errType ':
                  this.$message({message: '无此验证方式', type: 'error', customClass: 'mzindex'})
                  break
                case 'errNoTel':
                  this.$message({message: '此用户未绑定手机', type: 'error', customClass: 'mzindex'})
                  break
                case 'errTel':
                  this.$message({message: '此用户绑定手机匹配失败', type: 'error', customClass: 'mzindex'})
                  break
                case 'errNoEmail':
                  this.$message({message: '此用户未绑定邮箱', type: 'error', customClass: 'mzindex'})
                  break
                case 'errEmail':
                  this.$message({message: '此用户绑定邮箱匹配失败', type: 'error', customClass: 'mzindex'})
                  break
                case 'Verification code expired':
                  this.$message({message: '验证码失效', type: 'error', customClass: 'mzindex'})
                  break
                case 'Validation failed':
                  this.$message({message: '验证码错误', type: 'error', customClass: 'mzindex'}
                  )
                  break
                }
              }
            })
          }
          else
            this.$message({message: '请按照规则填写新密码或者确认密码', type: 'warning', customClass: 'mzindex'})
        })
      }
      else if (this.forgotPasswordForm.NewPwd === '' && this.forgotPasswordForm.confirmPwd !== '' && this.forgotPasswordForm.code !== '')
        this.$message({message: '请输入新密码', type: 'warning', customClass: 'mzindex'})
      else if (this.forgotPasswordForm.NewPwd !== '' && this.forgotPasswordForm.confirmPwd === '' && this.forgotPasswordForm.code !== '')
        this.$message({message: '请输入确认密码', type: 'warning', customClass: 'mzindex'})
      else if (this.forgotPasswordForm.NewPwd !== '' && this.forgotPasswordForm.confirmPwd !== '' && this.forgotPasswordForm.code === '')
        this.$message({message: '请输入验证码', type: 'warning', customClass: 'mzindex'})
      else
        this.$message({message: '请填写上述内容', type: 'warning', customClass: 'mzindex'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/wjmm/Validation.vue